import { render, staticRenderFns } from "./ResultTable.vue?vue&type=template&id=5c2dc91e&scoped=true&"
import script from "./ResultTable.js?vue&type=script&lang=js&"
export * from "./ResultTable.js?vue&type=script&lang=js&"
import style0 from "./ResultTable.scss?vue&type=style&index=0&id=5c2dc91e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2dc91e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Definition: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/Definition/Definition.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,WordActions: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordActions/WordActions.vue').default,CommerceWidget: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/CommerceWidget/index.vue').default,SeeMoreButton: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/ResultTable/components/SeeMoreButton.vue').default,Pagination: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Pagination/Pagination.vue').default})
